import { SVGProps } from 'react';
import { ReactComponent as ActualRhythm } from '../../../../../assets/icons/actual-rythm-legend.svg';
import { ReactComponent as AverageRhythm } from '../../../../../assets/icons/average-rythm-legend.svg';
import { ReactComponent as CurrentTime } from '../../../../../assets/icons/current-time-legend.svg';

export const LEGENDS: { icon: React.FC<SVGProps<SVGSVGElement>>; name: string; key: string }[] = [
  {
    icon: ActualRhythm,
    name: 'Actual Rhythm',
    key: 'actualRhythm',
  },
  {
    icon: AverageRhythm,
    name: 'Average Rhythm',
    key: 'averageRhythm',
  },
  {
    icon: CurrentTime,
    name: 'Current Time',
    key: 'currentTime',
  },
];
